export { getPageFilesClientSide };
import { getAllPageIdFilesClientSide } from '../getAllPageIdFiles';
function getPageFilesClientSide(pageFilesAll, pageId) {
    return getAllPageIdFilesClientSide(pageFilesAll, pageId);
}
